import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const initialState = {
  isButtonPressed: false,
  orderButtonIsPressed: false,
};

const rootSlice = createSlice({
  name: "root",
  initialState,
  reducers: {
    setIsButtonPressedAction: (state, action: PayloadAction<boolean>) => {
      state.isButtonPressed = action.payload;
    },
    setOrderButtonAction: (state, action: PayloadAction<boolean>) => {
      state.orderButtonIsPressed = action.payload;
    },
  },
});

export const { setIsButtonPressedAction, setOrderButtonAction } = rootSlice.actions;

export default rootSlice.reducer;
